import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../firebase';
import "../App.css";
import Menu from '../panel/Menu';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useReactToPrint } from 'react-to-print';
import numberToWords from "number-to-words";

function Printrqui() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });
    const printRef = useRef();
    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false)
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const { documentId } = useParams();

    const [poData, setpoData] = useState([]);
    const [poitems, setpoitems] = useState([]);
    const [username, setusername] = useState("");
    const [amountInWords, setAmountInWords] = useState("");



    useEffect(() => {
        fetchData1()
    }, []);


    const fetchData1 = async () => {
        try {
            const docRef = doc(db, "poregisters", documentId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setpoData(docSnap.data());
                const words = numberToWords.toWords(docSnap.data().pototal);
                setAmountInWords(words)
            }

            const q1 = query(collection(db, 'poitems'), where('poid', '==', documentId))
            onSnapshot(q1, async (querySnapshot1) => {
                const combinedData = [];
                for (const doc1 of querySnapshot1.docs) {
                    combinedData.push({
                        id: doc1.id,
                        data: doc1.data(),
                    });
                }
                setpoitems(combinedData);
            });

        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }


    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    return (
        <div>
            <Menu />
            {
                poData &&
                <div className="content-wrapper">
                    <section className="content mt-2">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="card card-primary card-outline" ref={printRef}>
                                        <div className='card-body'>

                                            <table className='customers'>
                                                <tr>
                                                    <td className='text-center'>
                                                        <h4>Dasara Executive</h4>
                                                        <h6>GSTIN No - 27AAGCD7108K1ZH</h6>
                                                        <b style={{ fontSize: 17 }}>
                                                            Chatrapati Shivaji Maharaj Chouk, Tuljapur, Dist - Dharashiv, MH - 413601<br />
                                                            Phone: +91 9975294940 | Email:  dasaraexecutive@gmail.com<br />
                                                            Website:  www.dasaraexecutive.com
                                                        </b>
                                                    </td>
                                                </tr>
                                            </table>
                                            <table className='customers'>
                                                <tr>
                                                    <td className='text-center'>
                                                        <b style={{ fontSize: 16 }}>REQUISITIONS</b>
                                                    </td>
                                                </tr>
                                            </table>
                                            <table className='customers'>
                                                <tr>
                                                    <td>
                                                        <b style={{ fontSize: 16 }}>Bill Date : {moment(poData.billdate).format('DD-MM-YYYY')}</b>
                                                    </td>
                                                    <td>
                                                        <b style={{ fontSize: 16 }}>PO Date :  {moment(poData.podate).format('DD-MM-YYYY')}</b>
                                                    </td>
                                                </tr>
                                            </table>

                                            <table className='customers'>
                                                <tr>
                                                    <td>
                                                        <b style={{ fontSize: 16 }}>From</b><br />
                                                        {poData.fromname}<br />
                                                        {poData.fromaddress}
                                                    </td>
                                                    <td>
                                                        <b style={{ fontSize: 16 }}>To</b><br />
                                                        {poData.toname}<br />
                                                        {poData.designation}
                                                    </td>

                                                </tr>
                                            </table>
                                            <table className='customers'>
                                                <tr>
                                                    <td>
                                                        <b style={{ fontSize: 16 }}>Subject : {poData.subject}</b><br />
                                                        <span style={{ fontSize: 16 }}>Budget Amount : {poData.budgetamount}</span><br />
                                                        <span style={{ fontSize: 16 }}>Approval Amount : {poData.approveamount}</span><br />
                                                    </td>
                                                </tr>
                                            </table>
                                            <table className='customers'>
                                                <tr>
                                                    <td style={{ fontSize: 16 }}>
                                                        Requirement of payment for <b > {poData.subject}</b>
                                                    </td>
                                                </tr>
                                            </table>
                                            <table className="customers">
                                                <tbody>
                                                    <tr>
                                                        <th>Sr No</th>
                                                        <th>Product </th>
                                                        <th>Descreption </th>
                                                        <th>Quantity </th>
                                                        <th>Size </th>
                                                        <th>Rate </th>
                                                        <th>Taxable </th>
                                                        <th>Gst  </th>
                                                        <th>Gst Amount </th>
                                                        <th>Total </th>
                                                    </tr>
                                                </tbody>
                                                {
                                                    poitems.map((item, num = 1) =>
                                                        <tr key={num + 1}>

                                                            <td width="80">{num + 1}</td>
                                                            <td>{item.data.product}</td>
                                                            <td>{item.data.descreption}</td>
                                                            <td>{item.data.quantity}</td>
                                                            <td>{item.data.size}</td>
                                                            <td>{item.data.rate}</td>
                                                            <td>{item.data.taxable}</td>
                                                            <td>{item.data.gst}</td>
                                                            <td>{item.data.gstamount}</td>
                                                            <td>{item.data.total}</td>


                                                        </tr>
                                                    )}
                                            </table>
                                            <table className='customers'>
                                                <tr>
                                                    <td>
                                                        <b style={{ fontSize: 16 }}>Grand Total  : Rs. {poData.pototal} /-</b><br />
                                                    </td>
                                                </tr>
                                            </table>
                                            <table className='customers'>
                                                <tr>
                                                    <td>
                                                        <b style={{ fontSize: 16, textTransform: "capitalize" }}>Total Invoice Value (in Words): {amountInWords} /-</b><br />
                                                    </td>
                                                </tr>
                                            </table>
                                            <table className='customers'>
                                                <tr>
                                                    <td>
                                                        <b style={{ fontSize: 16 }}>Payment Terms:</b><br />
                                                        <span>100% payment immedietly against delivery.</span><br /><br />
                                                        <span>With Regards,</span><br />
                                                        <span>Dept. Head.</span><br />
                                                    </td>
                                                </tr>
                                            </table>
                                            <table className='customers'>
                                                <tr>
                                                    <td className='text-center' width="50%">
                                                        &nbsp;
                                                    </td>
                                                    <td className='text-center'>
                                                        <div className='row'>
                                                            <div className='col-sm-6'>
                                                                <br /><br /><br /><b style={{ fontSize: 15 }}>Mr. Pravin Thombare</b>
                                                                <br /><b style={{ fontSize: 15 }}>General Manager</b><br />
                                                            </div>
                                                            <div className='col-sm-6'>
                                                                <br /><br /><br /><b style={{ fontSize: 15 }}>Pallavi Madam</b>
                                                                <br /><b style={{ fontSize: 15 }}>Final Approval</b><br />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>


                                        </div>
                                    </div>
                                    <center>
                                        <button className='btn btn-success' onClick={handlePrint}>Print Requisitions</button>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </section >


                </div >
            }



        </div >

    )
}


export default Printrqui
